<template>
    <div>
        <!-- Modal Formulario API Integradora -->
        <vs-dialog v-model="showFormularioApiModal" width="600px" not-center
            :style="{ zIndex: getModalZIndex('formulario') }">
            <div class="modal-header bg-primary">
                <i class="fas fa-search fa-3x mr-3"></i>
                <span class="h2 text-white font-weight-bold">Consultar API Integradora</span>
            </div>

            <div class="modal-content">
                <div class="modal-body">
                    <form @submit.prevent="consultarApiIntegradora">
                        <div class="form-group mb-3">
                            <label for="numero_identificacion_1" class="form-label-custom">
                                <i class="fas fa-id-card text-primary mr-2"></i> Número Identificación Uno
                            </label>
                            <input type="text" id="numero_identificacion_1"
                                v-model="formularioApi.numero_identificacion_1" class="form-control"
                                placeholder="Ej: 123456789" required>
                        </div>

                        <div class="form-group mb-3">
                            <label for="numero_identificacion_2" class="form-label-custom">
                                <i class="fas fa-id-card text-primary mr-2"></i> Número Identificación Dos
                            </label>
                            <input type="text" id="numero_identificacion_2"
                                v-model="formularioApi.numero_identificacion_2" class="form-control"
                                placeholder="Ej: 123456789" required>
                        </div>

                        <div class="form-group mb-3">
                            <label for="placa" class="form-label-custom">
                                <i class="fas fa-car text-info mr-2"></i> Placa
                            </label>
                            <input type="text" id="placa" v-model="formularioApi.placa" class="form-control"
                                placeholder="Ej: ABC123" required>
                        </div>

                        <div class="form-group mb-3">
                            <label for="nit" class="form-label-custom">
                                <i class="fas fa-building text-warning mr-2"></i> NIT de la Empresa
                            </label>
                            <input type="text" id="nit" v-model="formularioApi.nit" class="form-control"
                                placeholder="Ej: 123456789" required>
                        </div>

                        <div class="form-group mb-4">
                            <label for="fecha_consulta" class="form-label-custom">
                                <i class="fas fa-calendar text-success mr-2"></i> Fecha Consulta
                            </label>
                            <input type="date" id="fecha_consulta" v-model="formularioApi.fecha_consulta"
                                class="form-control" required>
                        </div>

                        <div class="text-center d-flex justify-content-center gap-2">
                            <vs-button type="submit" success :disabled="consultandoApi" class="btn-lg w-100">
                                <i v-if="consultandoApi" class="fas fa-spinner fa-spin mr-2"></i>
                                <i v-else class="fas fa-search mr-2"></i>
                                {{ consultandoApi ? 'Consultando...' : 'Consultar API' }}
                            </vs-button>
                            <vs-button @click="cerrarFormulario" color="danger" type="flat" class="btn-lg w-100"
                                :disabled="consultandoApi">
                                Cancelar
                            </vs-button>
                        </div>
                    </form>
                </div>
            </div>
        </vs-dialog>

        <!-- Modal de Carga durante consulta -->
        <vs-dialog v-model="showLoadingModal" width="400px" not-center :close-button="false"
            :style="{ zIndex: getModalZIndex('loading') }">
            <div class="modal-content">
                <div class="modal-body text-center py-4 card-with-border">
                    <div class="loading-spinner mb-3">
                        <i class="fas fa-spinner fa-spin fa-3x text-primary"></i>
                    </div>
                    <span class="h4 mb-2 d-block font-weight-bold">Realizando Consulta a la Super Transporte</span>
                    <span class="h6 mb-2 d-block">Por favor espere un momento mientras procesamos su solicitud...</span>
                    <div class="progress mt-3">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            style="width: 100%"></div>
                    </div>
                </div>
            </div>
        </vs-dialog>

        <!-- Modal Resultados API Integradora -->
        <vs-dialog v-model="showResultadosApiModal" width="90%" not-center
            :style="{ zIndex: getModalZIndex('resultados') }">
            <div class="modal-header text-white">
                <i class="fas fa-chart-line fa-3x mr-3"></i>
                <span class="modal-title">Resultados API Integradora</span>
            </div>

            <div v-if="resultadosApi" class="modal-content">
                <div class="modal-body">
                    <!-- Mensaje de éxito -->
                    <div class="alert alert-success text-center mb-4">
                        <i class="fas fa-check-circle fa-2x"></i>
                        <span class="h2 font-weight-bold d-block justify-content-center">
                            {{ resultadosApi.mensaje }}
                        </span>
                    </div>

                    <!-- Tabs Vue.js nativos con clases del sistema -->
                    <div class="card card-with-border">
                        <div class="card-header">
                            <!-- Tab Headers -->
                            <div class="vue-tab-headers">
                                <button v-for="tab in tabs" :key="tab.id" @click="activeTab = tab.id" :class="[
                                    'vue-tab-header btn',
                                    {
                                        'btn-primary': activeTab === tab.id,
                                        'btn-outline-secondary': activeTab !== tab.id
                                    }
                                ]">
                                    <i :class="tab.icon"></i> {{ tab.name }}
                                </button>
                            </div>
                        </div>

                        <div class="card-body card-with-border">
                            <!-- Tab Content -->
                            <div class="vue-tab-content">
                                <!-- Tab Conductores -->
                                <div v-if="activeTab === 'conductores'" class="vue-tab-pane">
                                    <div class="row">
                                        <!-- Conductor 1 -->
                                        <div class="col-md-6" v-if="resultadosApi.datos.conductor_1">
                                            <div class="card conductor-card card-with-border">
                                                <div class="card-header bg-dark text-white">
                                                    <span class="h5 font-weight-bold d-block mb-2">
                                                        <i class="fas fa-user mr-2"></i> Conductor 1
                                                    </span>
                                                </div>
                                                <div class="card-body card-with-border">
                                                    <!-- Información Personal -->
                                                    <div class="info-section">
                                                        <span class="h6 font-weight-bold d-block mb-2">Información
                                                            Personal:</span>
                                                        <div
                                                            v-if="hasValidData(resultadosApi.datos.conductor_1.persona)">
                                                            <span
                                                                class="h6 font-weight-bold d-block mb-2">Nombres:</span>
                                                            {{ resultadosApi.datos.conductor_1.persona.nombres }}
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                Apellidos: {{
                                                                    resultadosApi.datos.conductor_1.persona.apellidos }}
                                                            </span>
                                                        </div>
                                                        <div v-else class="no-data-message">
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                <i class="fas fa-info-circle mr-2"></i>
                                                                {{ resultadosApi.datos.conductor_1.persona.mensaje ||
                                                                    'No se encontró información personal' }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <!-- Licencia -->
                                                    <div class="info-section">
                                                        <span class="h6 font-weight-bold d-block mb-2">Licencia</span>
                                                        <div
                                                            v-if="hasValidData(resultadosApi.datos.conductor_1.licencia)">
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                Número: {{
                                                                    resultadosApi.datos.conductor_1.licencia.numero_licencia
                                                                }}
                                                            </span>
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                Expedición: {{
                                                                    resultadosApi.datos.conductor_1.licencia.fecha_expedicion
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div v-else class="no-data-message">
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                <i class="fas fa-info-circle mr-2"></i>
                                                                {{ resultadosApi.datos.conductor_1.licencia.mensaje ||
                                                                    'No se encontró información de licencia' }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <!-- Exámenes -->
                                                    <div class="info-section">
                                                        <span
                                                            class="h6 text-dark font-weight-bold d-block mb-2">Exámenes</span>
                                                        <div v-if="resultadosApi.datos.conductor_1.alcoholimetria?.resultado"
                                                            class="exam-result"
                                                            :class="getExamClass(resultadosApi.datos.conductor_1.alcoholimetria.resultado)">
                                                            <strong>Alcoholimetría:</strong> {{
                                                                resultadosApi.datos.conductor_1.alcoholimetria.resultado }}
                                                        </div>
                                                        <div v-if="resultadosApi.datos.conductor_1.examen_medico?.resultado"
                                                            class="exam-result"
                                                            :class="getExamClass(resultadosApi.datos.conductor_1.examen_medico.resultado)">
                                                            <strong>Examen Médico:</strong> {{
                                                                resultadosApi.datos.conductor_1.examen_medico.resultado }}
                                                        </div>
                                                        <div v-if="resultadosApi.datos.conductor_1.aptitud_fisica?.resultado"
                                                            class="exam-result"
                                                            :class="getExamClass(resultadosApi.datos.conductor_1.aptitud_fisica.resultado)">
                                                            <strong>Aptitud Física:</strong> {{
                                                                resultadosApi.datos.conductor_1.aptitud_fisica.resultado }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Conductor 2 -->
                                        <div class="col-md-6" v-if="resultadosApi.datos.conductor_2">
                                            <div class="card conductor-card card-with-border">
                                                <div class="card-header bg-dark text-white">
                                                    <span class="h5 font-weight-bold d-block mb-2">
                                                        <i class="fas fa-user mr-2"></i> Conductor 2
                                                    </span>
                                                </div>
                                                <div class="card-body card-with-border">
                                                    <!-- Información Personal -->
                                                    <div class="info-section">
                                                        <span class="h6 font-weight-bold d-block mb-2">Información
                                                            Personal:</span>
                                                        <div
                                                            v-if="hasValidData(resultadosApi.datos.conductor_2.persona)">
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                Nombres: {{
                                                                    resultadosApi.datos.conductor_2.persona.nombres }}
                                                            </span>
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                Apellidos: {{
                                                                    resultadosApi.datos.conductor_2.persona.apellidos }}
                                                            </span>
                                                        </div>
                                                        <div v-else class="no-data-message">
                                                            <i class="fas fa-info-circle mr-2"></i>
                                                            {{ resultadosApi.datos.conductor_2.persona.mensaje ||
                                                                'No se encontró información personal' }}
                                                        </div>
                                                    </div>

                                                    <!-- Licencia -->
                                                    <div class="info-section">
                                                        <span class="h6 font-weight-bold d-block mb-2">Licencia</span>
                                                        <div
                                                            v-if="hasValidData(resultadosApi.datos.conductor_2.licencia)">
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                Número: {{
                                                                    resultadosApi.datos.conductor_2.licencia.numero_licencia
                                                                }}
                                                            </span>
                                                            <span class="h6 font-weight-bold d-block mb-2">
                                                                Expedición: {{
                                                                    resultadosApi.datos.conductor_2.licencia.fecha_expedicion
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div v-else class="no-data-message">
                                                            <i class="fas fa-info-circle mr-2"></i>
                                                            {{ resultadosApi.datos.conductor_2.licencia.mensaje ||
                                                                'No se encontró información de licencia' }}
                                                        </div>
                                                    </div>

                                                    <!-- Exámenes -->
                                                    <div class="info-section">
                                                        <span
                                                            class="h6 text-dark font-weight-bold d-block mb-2">Exámenes</span>
                                                        <div v-if="resultadosApi.datos.conductor_2.alcoholimetria?.resultado"
                                                            class="exam-result"
                                                            :class="getExamClass(resultadosApi.datos.conductor_2.alcoholimetria.resultado)">
                                                            <strong>Alcoholimetría:</strong> {{
                                                                resultadosApi.datos.conductor_2.alcoholimetria.resultado }}
                                                        </div>
                                                        <div v-if="resultadosApi.datos.conductor_2.examen_medico?.resultado"
                                                            class="exam-result"
                                                            :class="getExamClass(resultadosApi.datos.conductor_2.examen_medico.resultado)">
                                                            <strong>Examen Médico:</strong> {{
                                                                resultadosApi.datos.conductor_2.examen_medico.resultado }}
                                                        </div>
                                                        <div v-if="resultadosApi.datos.conductor_2.aptitud_fisica?.resultado"
                                                            class="exam-result"
                                                            :class="getExamClass(resultadosApi.datos.conductor_2.aptitud_fisica.resultado)">
                                                            <strong>Aptitud Física:</strong> {{
                                                                resultadosApi.datos.conductor_2.aptitud_fisica.resultado }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tab Vehículo -->
                                <div v-if="activeTab === 'vehiculo'" class="vue-tab-pane">
                                    <div class="card info-card card-with-border">
                                        <div class="card-header bg-dark text-white">
                                            <span class="h5 font-weight-bold d-block mb-2">
                                                <i class="fas fa-car mr-2"></i> Información del Vehículo
                                            </span>
                                        </div>
                                        <div class="card-body card-with-border">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <p class="text-muted"><strong>Placa:</strong> {{
                                                        resultadosApi.datos.vehiculo.placa }}</p>
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="text-muted"><strong>SOAT Vencimiento:</strong> {{
                                                        resultadosApi.datos.vehiculo.soat_vencimiento }}</p>
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="text-muted"><strong>RTM Vencimiento:</strong> {{
                                                        resultadosApi.datos.vehiculo.rtm_vencimiento }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card info-card card-with-border mt-3"
                                        v-if="resultadosApi.datos.tarjeta_operacion">
                                        <div class="card-header bg-dark text-white">
                                            <span class="h5 font-weight-bold d-block mb-2">
                                                <i class="fas fa-id-card mr-2"></i> Tarjeta de Operación
                                            </span>
                                        </div>
                                        <div class="card-body card-with-border">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <p class="text-muted"><strong>Número:</strong> {{
                                                        resultadosApi.datos.tarjeta_operacion.numero }}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="text-muted"><strong>Estado:</strong>
                                                        <span class="badge">{{
                                                            resultadosApi.datos.tarjeta_operacion.estado }}</span>
                                                    </p>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="text-muted"><strong>Expedición:</strong> {{
                                                        resultadosApi.datos.tarjeta_operacion.fecha_expedicion }}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="text-muted"><strong>Vencimiento:</strong> {{
                                                        resultadosApi.datos.tarjeta_operacion.vencimiento }}</p>
                                                </div>
                                            </div>
                                            <p class="text-muted"><strong>Empresa Asociada:</strong> {{
                                                resultadosApi.datos.tarjeta_operacion.empresa_asociada }}</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tab Pólizas -->
                                <div v-if="activeTab === 'polizas'" class="vue-tab-pane">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="card info-card card-with-border">
                                                <div class="card-header bg-dark text-white">
                                                    <span class="h5 font-weight-bold d-block mb-2">
                                                        <i class="fas fa-shield-alt mr-2"></i> Póliza Contractual
                                                    </span>
                                                </div>
                                                <div class="card-body card-with-border">
                                                    <p class="text-muted"><strong>Estado:</strong>
                                                        <span class="badge">{{
                                                            resultadosApi.datos.polizas.contractual.estado }}</span>
                                                    </p>
                                                    <p class="text-muted"><strong>Vencimiento:</strong> {{
                                                        resultadosApi.datos.polizas.contractual.vencimiento }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="card info-card card-with-border">
                                                <div class="card-header bg-dark text-white">
                                                    <span class="h5 font-weight-bold d-block mb-2">
                                                        <i class="fas fa-shield-alt mr-2"></i> Póliza Extracontractual
                                                    </span>
                                                </div>
                                                <div class="card-body card-with-border">
                                                    <p class="text-muted"><strong>Estado:</strong>
                                                        <span class="badge">{{
                                                            resultadosApi.datos.polizas.extracontractual.estado
                                                            }}</span>
                                                    </p>
                                                    <p class="text-muted"><strong>Vencimiento:</strong> {{
                                                        resultadosApi.datos.polizas.extracontractual.vencimiento }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tab Mantenimiento -->
                                <div v-if="activeTab === 'mantenimiento'" class="vue-tab-pane">
                                    <div class="card info-card card-with-border mb-3"
                                        v-if="resultadosApi.datos.mantenimiento_preventivo">
                                        <div class="card-header bg-dark text-white">
                                            <span class="h5 font-weight-bold d-block mb-2">
                                                <i class="fas fa-tools mr-2"></i> Mantenimiento Preventivo
                                            </span>
                                        </div>
                                        <div class="card-body card-with-border">
                                            <p class="text-muted"><strong>ID:</strong> {{
                                                resultadosApi.datos.mantenimiento_preventivo.id }}</p>
                                            <p class="text-muted"><strong>Fecha:</strong> {{
                                                resultadosApi.datos.mantenimiento_preventivo.fecha }}</p>
                                            <p class="text-muted"><strong>Actividades:</strong> {{
                                                resultadosApi.datos.mantenimiento_preventivo.detalleActividades }}</p>
                                        </div>
                                    </div>

                                    <div class="card info-card card-with-border mb-3"
                                        v-if="resultadosApi.datos.mantenimiento_correctivo">
                                        <div class="card-header bg-dark text-white">
                                            <span class="h5 font-weight-bold d-block mb-2">
                                                <i class="fas fa-wrench mr-2"></i> Mantenimiento Correctivo
                                            </span>
                                        </div>
                                        <div class="card-body card-with-border">
                                            <p class="text-muted"><strong>ID:</strong> {{
                                                resultadosApi.datos.mantenimiento_correctivo.id }}</p>
                                            <p class="text-muted"><strong>Fecha:</strong> {{
                                                resultadosApi.datos.mantenimiento_correctivo.fecha }}</p>
                                            <p class="text-muted"><strong>Actividades:</strong> {{
                                                resultadosApi.datos.mantenimiento_correctivo.detalleActividades }}</p>
                                        </div>
                                    </div>

                                    <div class="card info-card card-with-border"
                                        v-if="resultadosApi.datos.alistamiento_diario">
                                        <div class="card-header bg-dark text-white">
                                            <span class="h5 font-weight-bold d-block mb-2">
                                                <i class="fas fa-clipboard-check mr-2"></i> Alistamiento Diario
                                            </span>
                                        </div>
                                        <div class="card-body card-with-border">
                                            <p class="text-muted"><strong>ID:</strong> {{
                                                resultadosApi.datos.alistamiento_diario.id }}</p>
                                            <p class="text-muted"><strong>Fecha:</strong> {{
                                                resultadosApi.datos.alistamiento_diario.fecha }}</p>
                                            <p class="text-muted"><strong>Actividades:</strong> {{
                                                resultadosApi.datos.alistamiento_diario.detalleActividades }}</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tab Autorizaciones -->
                                <div v-if="activeTab === 'autorizaciones'" class="vue-tab-pane">
                                    <div class="card info-card card-with-border">
                                        <div class="card-header bg-dark text-white">
                                            <span class="h5 font-weight-bold d-block mb-2">
                                                <i class="fas fa-check-circle mr-2"></i> Autorizaciones de Viaje
                                            </span>
                                        </div>
                                        <div class="card-body card-with-border">
                                            <div
                                                v-if="resultadosApi.datos.autorizaciones && resultadosApi.datos.autorizaciones.length > 0">
                                                <div class="alert alert-info mb-3">
                                                    <i class="fas fa-info-circle mr-2"></i>
                                                    <strong>Total de autorizaciones encontradas: {{
                                                        resultadosApi.datos.autorizaciones.length }}</strong>
                                                </div>

                                                <div class="table-responsive">
                                                    <table class="table table-striped table-hover">
                                                        <thead class="thead-dark">
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Código</th>
                                                                <th scope="col">Fecha del Viaje</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(autorizacion, index) in resultadosApi.datos.autorizaciones"
                                                                :key="index">
                                                                <td>{{ index + 1 }}</td>
                                                                <td>
                                                                    <span class="">{{ autorizacion.codigo }}</span>
                                                                </td>
                                                                <td>
                                                                    <span class="">{{ autorizacion.fechaViaje }}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div v-else class="no-data-message">
                                                <i class="fas fa-exclamation-triangle mr-2"></i>
                                                <strong>No se encontraron autorizaciones de viaje para este
                                                    vehículo.</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Tab Empresa -->
                                <div v-if="activeTab === 'empresa'" class="vue-tab-pane">
                                    <div class="card info-card card-with-border">
                                        <div class="card-header bg-dark text-white">
                                            <span class="h5 font-weight-bold d-block mb-2">
                                                <i class="fas fa-building mr-2"></i> Información de la Empresa
                                            </span>
                                        </div>
                                        <div class="card-body card-with-border">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <p class="text-muted"><strong>ID Empresa:</strong> {{
                                                        resultadosApi.datos.empresa.ID_EMPRESA }}</p>
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="text-muted"><strong>NIT:</strong> {{
                                                        resultadosApi.datos.empresa.NIT }}</p>
                                                </div>
                                                <div class="col-md-12">
                                                    <p class="text-muted"><strong>Razón Social:</strong> {{
                                                        resultadosApi.datos.empresa.RAZON_SOCIAL }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer d-flex justify-content-center">
                    <vs-button @click="cerrarResultados" color="primary" class="btn-lg">
                        <i class="fas fa-times mr-2"></i> Cerrar
                    </vs-button>
                </div>
            </div>
        </vs-dialog>
    </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
    name: "ApiIntegradoraConsulta",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        vehiculoSeleccionado: {
            type: Object,
            default: null
        },
        persona: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showFormularioApiModal: false,
            showResultadosApiModal: false,
            showLoadingModal: false, // Separado del estado consultandoApi
            consultandoApi: false,
            resultadosApi: null,
            activeTab: 'conductores',
            modalZIndexBase: 1050, // Z-index base para los modales
            formularioApi: {
                numero_identificacion_1: '',
                numero_identificacion_2: '',
                placa: '',
                nit: '',
                fecha_consulta: ''
            },
            tabs: [
                { id: 'conductores', name: 'Conductores', icon: 'fas fa-users' },
                { id: 'vehiculo', name: 'Vehículo', icon: 'fas fa-car' },
                { id: 'polizas', name: 'Pólizas', icon: 'fas fa-shield-alt' },
                { id: 'mantenimiento', name: 'Mantenimiento', icon: 'fas fa-tools' },
                { id: 'autorizaciones', name: 'Autorizaciones', icon: 'fas fa-check-circle' },
                { id: 'empresa', name: 'Empresa', icon: 'fas fa-building' }
            ]
        }
    },
    computed: {
        // Computed para manejar el estado de los modales de forma más controlada
        activeModalsCount() {
            let count = 0
            if (this.showFormularioApiModal) count++
            if (this.showLoadingModal) count++
            if (this.showResultadosApiModal) count++
            return count
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                console.log('Prop visible cambió a:', newVal)
                if (newVal) {
                    this.abrirFormulario()
                } else {
                    this.cerrarTodosLosModales()
                }
            },
            immediate: true
        },

        showFormularioApiModal(newVal) {
            if (!newVal && this.visible && !this.showLoadingModal && !this.showResultadosApiModal) {
                this.$emit('cerrar')
            }
        },

        showResultadosApiModal(newVal) {
            if (!newVal && this.visible && !this.showFormularioApiModal && !this.showLoadingModal) {
                this.$emit('cerrar')
            }
        }
    },
    created() {
        console.log('Componente creado con visible:', this.visible)
        this.inicializarFormulario()
    },
    methods: {
        // Método para calcular z-index dinámicamente
        getModalZIndex(modalType) {
            const zIndexMap = {
                'formulario': this.modalZIndexBase,
                'loading': this.modalZIndexBase + 10,
                'resultados': this.modalZIndexBase + 5
            }
            return zIndexMap[modalType] || this.modalZIndexBase
        },

        // Método para cerrar todos los modales de forma segura
        cerrarTodosLosModales() {
            this.showFormularioApiModal = false
            this.showLoadingModal = false
            this.showResultadosApiModal = false
            this.consultandoApi = false
        },

        // Método para abrir el formulario de forma controlada
        abrirFormulario() {
            this.cerrarTodosLosModales()
            this.prepararFormulario()
            // Usar nextTick para asegurar que los modales se cierren antes de abrir el nuevo
            this.$nextTick(() => {
                this.showFormularioApiModal = true
            })
        },

        inicializarFormulario() {
            this.formularioApi.fecha_consulta = new Date().toISOString().split('T')[0]
            this.prepararFormulario()
        },

        prepararFormulario() {
            console.log('Preparando formulario con vehículo:', this.vehiculoSeleccionado)
            if (this.vehiculoSeleccionado?.placa) {
                this.formularioApi.placa = this.vehiculoSeleccionado.placa
            }
            if (this.persona?.empresa?.nit) {
                this.formularioApi.nit = this.persona.empresa.nit
            }
        },

        hasValidData(dataObject) {
            if (!dataObject) return false
            if (dataObject.mensaje) return false

            const dataKeys = Object.keys(dataObject).filter(key => key !== 'mensaje')
            return dataKeys.length > 0 && dataKeys.some(key => dataObject[key] && dataObject[key] !== '')
        },

        async consultarApiIntegradora() {
            // Cerrar el formulario y mostrar loading de forma secuencial
            this.consultandoApi = true
            this.showFormularioApiModal = false

            // Esperar un momento antes de mostrar el modal de carga
            await this.$nextTick()
            this.showLoadingModal = true

            try {
                const response = await this.$store.dispatch("hl_post_cookie", {
                    path: "ApiSuperTransporteTerminales/api-integradora",
                    data: this.formularioApi
                })
                console.log("Respuesta de la ST:", response)

                this.resultadosApi = typeof response === 'string' ? JSON.parse(response) : response

                if (this.resultadosApi) {
                    // Cerrar loading y mostrar resultados de forma secuencial
                    this.showLoadingModal = false
                    await this.$nextTick()

                    this.activeTab = 'conductores'
                    this.showResultadosApiModal = true
                    this.mostrarNotificacionExito()
                } else {
                    throw new Error('No se recibió respuesta del servidor')
                }

            } catch (error) {
                console.error('Error al consultar API integradora:', error)
                this.showLoadingModal = false
                this.mostrarNotificacionError()
            } finally {
                this.consultandoApi = false
            }
        },

        cerrarFormulario() {
            console.log('Cerrando formulario')
            this.showFormularioApiModal = false
            this.limpiarFormulario()
            this.$emit('cerrar')
        },

        cerrarResultados() {
            console.log('Cerrando resultados')
            this.showResultadosApiModal = false
            this.resultadosApi = null
            this.activeTab = 'conductores'
            this.$emit('cerrar')
        },

        limpiarFormulario() {
            this.formularioApi = {
                numero_identificacion_1: '',
                numero_identificacion_2: '',
                placa: '',
                nit: this.persona?.empresa?.nit || '',
                fecha_consulta: new Date().toISOString().split('T')[0]
            }
        },

        getExamClass(resultado) {
            if (!resultado) return ''

            const resultadoLower = resultado.toLowerCase()
            if (resultadoLower.includes('apto') || resultadoLower.includes('negativo')) {
                return 'exam-positive'
            } else if (resultadoLower.includes('no apto') || resultadoLower.includes('positivo')) {
                return 'exam-negative'
            }
            return ''
        },

        formatearFecha(fecha) {
            if (!fecha) return 'N/A'
            try {
                return new Date(fecha).toLocaleDateString('es-ES')
            } catch {
                return fecha
            }
        },

        mostrarNotificacionExito() {
            Swal.fire({
                title: 'Consulta Exitosa',
                text: 'Los datos se han consultado correctamente',
                icon: 'success',
                timer: 3000,
                showConfirmButton: false,
                toast: true,
                position: 'top-end'
            })
        },

        mostrarNotificacionError() {
            Swal.fire({
                title: 'Error en la consulta',
                text: 'Ocurrió un error al consultar la API. Por favor, intente nuevamente.',
                icon: 'error',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#dc3545'
            })
        }
    }
}
</script>

<style scoped>
/* Z-index específicos para evitar superposición */
.vs-dialog {
    position: fixed !important;
}

.vs-dialog[style*="z-index: 1050"] {
    z-index: 1050 !important;
}

.vs-dialog[style*="z-index: 1055"] {
    z-index: 1055 !important;
}

.vs-dialog[style*="z-index: 1060"] {
    z-index: 1060 !important;
}

.card-with-border {
    border: 1px solid rgba(0, 0, 0, 0.125);
    background-color: transparent;
}

.no-data-message {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 12px;
    color: #6c757d;
    font-style: italic;
    text-align: center;
}

.no-data-message i {
    color: #007bff;
}

.modal-content {
    border-radius: 15px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 15px 15px 0 0;
    padding: 20px;
}

.modal-title {
    font-size: 1.8rem;
    font-weight: 600;
}

.modal-body {
    padding: 30px;
}

.modal-footer {
    border-radius: 0 0 15px 15px;
    padding: 20px;
}

.loading-spinner {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
}

.vue-tab-headers {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 20px;
    justify-content: center;
}

.vue-tab-header {
    font-weight: 600;
    padding: 12px 24px;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    font-size: 0.95rem;
    border: 2px solid transparent;
}

.vue-tab-header i {
    margin-right: 8px;
}

.vue-tab-content {
    min-height: 300px;
}

.vue-tab-pane {
    animation: fadeInUp 0.4s ease-in-out;
}

.conductor-card,
.info-card {
    margin-bottom: 20px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.info-section {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e9ecef;
}

.info-section:last-child {
    border-bottom: none;
}

.exam-result {
    padding: 8px 12px;
    border-radius: 6px;
    margin-bottom: 5px;
    font-weight: 600;
}

.exam-positive {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.exam-negative {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.badge {
    font-size: 0.875rem;
    padding: 6px 12px;
    border-radius: 20px;
}

.btn-lg {
    padding: 12px 30px;
    font-size: 1.1rem;
    border-radius: 25px;
}

.table-responsive {
    border-radius: 8px;
    overflow: hidden;
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 123, 255, 0.1);
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .modal-body {
        padding: 15px;
    }

    .conductor-card .card-body,
    .info-card .card-body {
        padding: 15px;
    }

    .vue-tab-header {
        padding: 10px 16px;
        font-size: 0.85rem;
        margin-bottom: 8px;
    }

    .vue-tab-headers {
        justify-content: center;
        gap: 4px;
    }
}
</style>